<template>
  <div class="container-auditor">
    <div class="title">
      用印审批
    </div>
    <template v-for="(item, i) of signAuditor">
      <div class="item" :key="'signAuditor_0' + i">
        <div class="desc">
          <div>
            <img
              width="113px"
              :src="fileOperShow(item)"
              :title="item.sealName"
            />
          </div>
          <div style="margin-left:30px">
            <p class="userName">{{ item.sealName }}</p>
            <p class="user-tilte-color">
              申请人：
            </p>
            <p class="userName">{{ item.initiateName }}</p>
            <p v-if="item.taskDetail">{{ item.taskDetail.taskCreateTime }}</p>
          </div>
        </div>
        <!-- <div class="chap" :class="status(item.signStatus)">
          <div class="chap-box">{{ statusText(item.signStatus) }}</div>
        </div> -->
      </div>
      <div class="content" :key="'signAuditor_' + i">
        <p class="tit">
          共{{ (item.taskDetail && item.taskDetail.nodes && item.taskDetail.nodes.length) || 0 }}方
        </p>
        <div class="obj-box" v-if="item.taskDetail">
          <template v-for="(v, index) in item.taskDetail.nodes || []">
            <div
              class="obj"
              v-for="(apUser,i) of v.taskList || []"
              :key="index+'_'+ i"
            >
              <template v-if="apUser.userId === dingTalkUserId">
                <el-tooltip
                  effect="dark"
                  :content="apUser.name + '(我)'"
                  placement="bottom"
                >
                  <div class="user">
                    <span class="el-icon-user-solid"></span>
                  </div>
                </el-tooltip>
              </template>
              <template v-else>
                <el-tooltip
                  effect="dark"
                  :content="apUser.name"
                  placement="bottom"
                >
                  <div class="user">
                    <span class="el-icon-user-solid"></span>
                  </div>
                </el-tooltip>
              </template>
              <div class="obj-other">
                <p class="userName">{{ apUser.name }}</p>
                <div class="status text-color-green" v-if="comstatus(apUser) === 1">
                  已同意
                </div>
                <div class="status text-color-red" v-if="comstatus(apUser) === 2">
                  已驳回
                </div>
                <div class="status" v-if="comstatus(apUser) === 0">未审批</div>
                <div class="time" v-if="apUser.finishTime">{{ apUser.finishTime }}</div>
                <!-- <div class="reason" v-if="apUser.refuseReason">
                  拒绝原因: {{ apUser.refuseReason }}
                </div> -->
              </div>
              <el-button
                v-if="comstatus(apUser) === 0"
                class="approver-bth-sty"
                plain
                type="primary"
                size="small"
                :disabled="!!(item.taskDetail.node && item.taskDetail.nodes.length > 1) && indexFlowStatus(item.taskDetail.nodes) !== index"
                @click="urgentReview({user:apUser,item})"
              >催审</el-button>
            </div>
          </template>
          
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { fileOperShow } from "@/assets/js/http-serve/http-methods";
import {ApiCorpMethods} from "@/assets/js/http-serve/corp/http-methods";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi"

export default {
  name: "audit-detail",
  props: {
    signAuditor: {
      type: Array,
      defualt: []
    },
    singInfo:{
      type:Object,
      default:{}
    }
  },
  data() {
    return {
      fileOperShow
    };
  },
  created() {
    this.new_signAuditor = this.$utils.clone(this.signAuditor);
    console.log('this.new_signAuditor',this.new_signAuditor);
  },
  computed: {
    dingTalkUserId(){
      const { dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo"))
      console.log('dingTalkUserId',dingTalkUserId);
      return dingTalkUserId
    },
    statusText() {
      return function(val) {
        let str = "";
        switch (val) {
          case 0:
            str = "未流转";
            break;
          case 1:
            str = "已通过";
            break;
          case 2:
            str = "未通过";
          default:
            break;
        }
        return str;
      };
    },
    status() {
      return function(val) {
        let str = "";
        switch (val) {
          case 0:
            str = "default";
            break;
          case 1:
            str = "suc";
            break;
          case 2:
            str = "fail";
          default:
            break;
        }
        return str;
      };
    }
  },
  mounted() {
  },
  methods: {
    /** 返回当前催审进度下标 */
    indexFlowStatus(nodes){
      console.log('nodes',nodes);
      const index = nodes.findIndex(node => this.comstatus(node.taskList[0]) !== 1)
      console.log('index',index);
      return index
    },
    /** 催审 */
      urgentReview({user,item}){
        const {dingTalkCorpId:corpId,dingTalkUserId} = JSON.parse(sessionStorage.getItem("dingloginInfo")),
          {applyNo,contractName}=this.singInfo,{taskDetail,sealName:objectName}=item, _this = this;
        const param = { 
          corpId, 
          dingTalkUserId,
          procInstId:taskDetail.procInstId,
          applyNo,
          objectName,
          remindUserId:user.userId,
          remindType:2 
        }
        // remindType 催审类型，1：合同，2：用印
        dingtalkApi.remindAudit(param).then(res=>{
          if(!res.success) return _this.$message.error(res.description)
          _this.$message.success(res.description)
        })
      },
    /** 处理审批状态 */
    comstatus(obj){
      return obj.result === 'AGREE' ? 1 : obj.result === 'REFUSE' ? 2 : 0
    },
    sendApproveSealSms (partyId) {
      const {signNo,ts,sign} = this.$route.query
      ApiCorpMethods.CorpSealSignInfoController.sendApproveSealSms({
        signNo,
        ts,
        sign,
        partyId
      }).then(res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        this.$message.success("成功发送提醒通知");
      });
    },
    allStatus(item) {
      //0未审批1审批过2没审批通过3审批中
      if (item) {
        switch (item.flowStatus) {
          case 0:
            return "待审批";
            break;
          case 1:
            return "已通过";
            break;
          case 2:
            return "未通过";
            break;
          case 3:
            return "审批中";
            break;
          default:
            return "";
            break;
        }
      }
    },
    colorStatus(item) {
      //0未审批1审批过2没审批通过3审批中
      if (item) {
        switch (item.flowStatus) {
          case 1:
            return "#86DEA8";
          case 2:
            return "#EC1C1C";
          case 3:
            return "#FF9900";
          default:
            return "#000000";
        }
      }
    },
    /**
     * 自动换行
     * @param v 值
     * @param number
     */
    autoNewLine(v, number) {
      let d = "";
      for (let index = 0; index < v.length; index++) {
        const element = v[index];
        if (index > 0 && index % number === 0) {
          d += "\r\n";
        }
        d += element;
      }
      return d;
    }
  },
  beforeDestroy() {}
};
</script>
<style>
.el-tooltip__popper {
  max-width: 300px;
  white-space: normal;
  word-break: break-all;
}
</style>
<style scoped lang="less">
@import "../../assets/style/publicVar.css";
.user-tilte-color {
  color: var(--dark-color) !important;
}
.container-auditor {
  width: 100%;
  margin-top: 15px;
}

.container-auditor .item {
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  margin: 15px 0;
  padding: 15px;
  position: relative;

  .user {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    border: 1px solid #eeeeee;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    span {
      font-size: 32px;
      color: #eeeeee;
      border: 4px solid #eeeeee;
      border-radius: 50%;
    }
  }

  .chap {
    position: absolute;
    width: 75px;
    height: 75px;
    box-sizing: border-box;
    border: 2px solid transparent;
    border-radius: 50%;
    display: flex;
    top: -35px;
    right: 110px;
    align-items: center;
    justify-content: center;

    .chap-box {
      border-radius: 50%;
      border: 1px solid transparent;
      width: 62px;
      height: 62px;
      text-align: center;
      line-height: 62px;
      font-size: 16px;
      font-weight: bold;
      transform: rotate(315deg);
    }
  }

  .chap.suc {
    border-color: #86dea8;

    .chap-box {
      border-color: #86dea8;
      color: #86dea8;
    }
  }
  .chap.default {
    border-color: #dddddd;

    .chap-box {
      border-color: #dddddd;
      color: #dddddd;
    }
  }
  .chap.fail {
    border-color: #ec1c1c;

    .chap-box {
      border-color: #ec1c1c;
      color: #ec1c1c;
    }
  }

  .desc {
    width: auto;
    // height: 50px;
    display: flex;
    align-items: center;
    margin-left: 15px;

    p {
      font-size: 13px;
      color: #cccccc;

      span {
        margin-left: 20px;
      }
    }

    p.userName {
      color: #000000;
      font-size: 15px;
      font-weight: bold;
    }
  }
}

.container-auditor .content {
  width: 100%;
  // height: 560px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  padding: 10px 15px;
  .tit {
    height: 30px;
    line-height: 30px;
    width: 100%;
  }
  .obj-box {
    overflow: auto;
    overflow-x: hidden;
    position: relative;
    width: 100%;
    // height: 510px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .obj {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    min-height: 70px;
    height: auto;
    position: relative;
    margin-bottom: 30px;
    .approver-bth-sty{
        position: absolute;
        top: 30px;
        right: 16px;
      }
    &:not(:first-child) {
      /*border-top: 1px #eeeeee dashed;*/
      &:after {
        content: "";
        position: absolute;
        width: 640px;
        border: 1px #eeeeee dashed;
        height: 0px;
        top: -15px;
        left: 86px;
      }
      .user {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        border: 1px solid #eeeeee;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        span {
          font-size: 32px;
          color: #eeeeee;
          border: 4px solid #eeeeee;
          border-radius: 50%;
        }
      }
    }
    .user {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      border: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      span {
        font-size: 32px;
        color: #eeeeee;
        border: 4px solid #eeeeee;
        border-radius: 50%;
      }
    }
    .obj-other {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 70px;
      height: auto;
      margin-top: 10px;
      margin-left: 30px;
      .status {
        color: rgba(0, 0, 0, 0.65);
      }
      .text-color-red {
        color: red;
      }
      .text-color-green {
        color: #86dea8;
      }
      .reason {
        width: 640px;
        color: red;
        cursor: pointer;
      }
    }
  }
}

.title {
  width: 100%;
  font-weight: bold;
  font-size: 14px;

  .isOrder {
    font-size: 10px;
    padding: 2px 5px;
    color: #ffffff;
    background-color: #f0d092;
  }
}
</style>



// WEBPACK FOOTER //
// components/auditDetail/dingSignApprove.vue